
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/room/[roomTypeDescription]/[roomTypeId]",
      function () {
        return require("private-next-pages/room/[roomTypeDescription]/[roomTypeId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/room/[roomTypeDescription]/[roomTypeId]"])
      });
    }
  